<template>
  <div class="card-sections-block-header-tmk">

    <el-row type="flex" justify="space-between" style="margin-bottom: 20px">
      <div class="card-sections-block-header-title">
        <div style="font-size: 24px">
          Цели
        </div>
        <card-elements-view-switch></card-elements-view-switch>
      </div>

      <div>
        <card-next-and-previous-links
          button-size="mini"
          button-type="default"
        ></card-next-and-previous-links>
      </div>

      <div>
        <history-modal
          v-if="$canAndRulesPass(card, 'card.see_history')"
          style="display: inline-block; margin-left:35px"
          title="История изменений карты"
          width="70%"
          show-model-full-name
          :method="$api.card.getCardHistory"
          :params="{  id: card.id }"
        >
          <el-button
            slot="reference"
            type="text"
            size="mini"
            icon="fas fa-history"
          >
            История изменений
          </el-button>
        </history-modal>

        <el-button
          v-if="$canAndRulesPass(card, $permissions.CARD.EXPORT)"
          style="margin-left:35px"
          type="text"
          size="mini"
          icon="fas fa-file-excel"
          :loading="loadingDownloader"
          @click="exportToExcel"
        >
          Экспорт в XLSX
        </el-button>

        <start-dynamic-stage-button
          v-if="
            $canAndRulesPass(card, $permissions.CARD_STAGE.CREATE_DYNAMIC)
            && currentStage
            && currentStage.type === $constants.stage.types.TYPE_ASSESSMENT
            && !currentStage.current_negotiation_id
          "
          style="margin-left:35px"
          :card="card"
          stage-type="correction"
        >

          Запустить корректировку
        </start-dynamic-stage-button>

      </div>
    </el-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import HistoryModal from "@/components/HistoryModal.vue";
import {downloader} from "@/mixins/downloader";
import ClickToEdit from "@/components/ClickToEdit.vue";
import {cardInfoField} from "@/mixins/cardInfoField";
import CardNextAndPreviousLinks from "@/components/cards/CardNextAndPreviousLinks";
import StartDynamicStageButton from "@/components/cards/StartDynamicStageButton.vue";
import CardElementsViewSwitch from "@/components/cards/CardElementsBlock/CardElementsViewSwitch.vue";

export default {
  name: "card-sections-block-header",
  mixins: [downloader, cardInfoField],
  components: { CardElementsViewSwitch, StartDynamicStageButton, ClickToEdit, HistoryModal, CardNextAndPreviousLinks},
  props: {},
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card:'card'
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
    }),
    ...mapGetters('card/sections', {
      sectionsElements: 'sectionsElements'
    }),
  },
  watch: {},
  data() {
    return {
      loadingNotify: false,
    }
  },
  methods: {
    changeBonus(){
      this.infoFieldChanged('final_estimate')
        .then(()=>{
          this.$store.dispatch('card/loadCardData');
          this.$store.dispatch('card/stages/loadStages');
        })
    },
    exportToExcel() {
      this.downloadFile(
        'export.xlsx',
        this.$api.exportImport.export,
        {
          entity: 'card',
          data: {
            id: this.card.id
          }}
      )
    },
  }
}
</script>

<style lang="scss" scoped>
.card-sections-block-header-title {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>